import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InterviewNotes  {
    _originalTypeClassName = "zERP.BO.InterviewNotes";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InterviewNotes.translate = translateService;
}
this.Id = null;
this.NoteDate = null;
this.Text = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
NoteDate:any;
Text:any;
Account:any;
Interview:any;
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setInterview = ($this, value) => {
var oldValue = $this.Interview;
$this.Interview = value;
if (value != null) {
if (oldValue != null) {
Domain.ExitInterview.removeInterviewNotes(oldValue, $this);
}
Domain.ExitInterview.addInterviewNotes(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}